import './plugins/g-map';
import './plugins/icon';
import './plugins/mask';
import './plugins/validator';
import './registerServiceWorker';
import '@fortawesome/fontawesome-free/js/all';
import 'bootstrap';

import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
